import React from 'react';

const FAQSchema = () => {
  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is people-pleasing therapy?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "People-pleasing therapy helps you break free from patterns of over-accommodating others at your own expense. We work on understanding why you default to saying yes, how to set boundaries even when guilt or anxiety show up, and how to honor your own needs while staying connected to others. This therapy is rooted in attachment theory, nervous system regulation, and self-compassion."
        }
      },
      {
        "@type": "Question",
        "name": "Do you offer online therapy?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! All therapy sessions are conducted online via secure video conferencing. This means you can access therapy from anywhere in California—whether you're in Palo Alto, San Francisco, San Jose, the Bay Area, or anywhere throughout the state. Online therapy gives you the flexibility to meet from the comfort of your home, office, or anywhere private."
        }
      },
      {
        "@type": "Question",
        "name": "How long does therapy typically last?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Therapy length varies based on your goals and needs. Some clients see significant shifts in 3-6 months, while deeper work around trauma or long-standing patterns may take 6-12 months or longer. We'll check in regularly about your progress and adjust as needed. You're always in the driver's seat."
        }
      },
      {
        "@type": "Question",
        "name": "Do you take insurance?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "I'm an out-of-network provider, which means I don't bill insurance directly. However, I can provide you with a superbill (detailed receipt) that you can submit to your insurance for potential reimbursement. Many PPO plans cover a portion of out-of-network therapy. I'm happy to discuss this during our consultation."
        }
      },
      {
        "@type": "Question",
        "name": "What's the difference between people-pleasing and being kind?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Being kind comes from choice and genuine care. People-pleasing comes from fear—fear of rejection, conflict, or disappointing others. With kindness, you can still say no and maintain your boundaries. With people-pleasing, saying no feels impossible or terrifying, and you regularly abandon your own needs to keep others comfortable. Therapy helps you distinguish between the two and you can heal."
        }
      },
      {
        "@type": "Question",
        "name": "What should I expect in the first session?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The first session is all about getting to know you and what brought you to therapy. We'll talk about your goals, your history, and what patterns you want to shift. I'll also explain how I work and answer any questions you have. There's no pressure to dive into anything heavy right away—we move at your pace."
        }
      },
      {
        "@type": "Question",
        "name": "How do I know if therapy is working?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You'll notice shifts like: saying no without excessive guilt, feeling more grounded in your body, having more honest conversations, noticing your patterns before you act on them, and feeling less anxious in relationships. Progress isn't always linear, but you'll start to see changes in how you relate to yourself and others."
        }
      }
    ]
  };

  return (
    <script 
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(faqData) }}
    />
  );
};

export default FAQSchema;
